import { ImageColorFinderFlight, Project } from "@nova/protobuf"
import {
    booleanValidator,
    genericCreateLayerValidator,
    UnionToTuple,
    updateLayerValidator,
} from "../util"
import { dateAsNumber } from "../../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"
export const createImageColorFinderFlightValidator = genericCreateLayerValidator

export const updateImageColorFinderFlightValidator = updateLayerValidator(ImageColorFinderFlight, {
    processAfterUpload: {
        validators: booleanValidator("processAfterUpload must be a boolean value"),
    },
    cumulativeColorIndex: {
        nonNull: true,
        validators: [],
    },
    anomalyPath: {
        nonNull: true,
        validators: [],
    },
    colorDataPath: {
        nonNull: true,
        validators: [],
    },
})

export const getDefaultImageColorFinderFlightCreateArgs = (
    project: Project,
    inParentId?: string
) => ({
    visible: true,
    createdAt: dateAsNumber(),
    images: [],
    index: createNewLayerFractionalIndex(project, 0, inParentId),
    processAfterUpload: true,
    cumulativeColorIndex: new Uint8Array(0),
    anomalyPath: "",
    colorDataPath: "",

    // parentId would never got autopopulated
    parentId: undefined,
})

export type CreateImageColorFinderFlightArgs = UnionToTuple<
    keyof typeof createImageColorFinderFlightValidator
>
export type UpdateImageColorFinderFlightArgs = UnionToTuple<
    keyof typeof updateImageColorFinderFlightValidator
>
